import type {
  Workspace,
  WorkspacePatchBody,
  WorkspaceSummary,
  WorkspaceWriteBody,
} from '../types/workspace.js';

export interface IWorkspaceService {
  list(): Promise<WorkspaceSummary[]>;
  get(name: string): Promise<Workspace>;
  create(name: string, body: WorkspaceWriteBody): Promise<Workspace>;
  patch(
    name: string,
    body: WorkspacePatchBody,
    etag: string,
  ): Promise<Workspace>;
  delete(name: string): Promise<void>;
}

export class WorkspaceNotFoundError extends Error {
  readonly code = 'WorkspaceNotFound';
  constructor(name: string) {
    super(`Workspace '${name}' does not exist.`);
  }
}

export class WorkspaceAlreadyExistsError extends Error {
  readonly code = 'ResourceAlreadyExists';
  constructor(name: string) {
    super(`A workspace named '${name}' already exists.`);
  }
}

export class WorkspaceEtagMissingError extends Error {
  readonly code = 'WorkspaceEtagMissing';
  constructor(name: string) {
    super(
      `Workspace '${name}' did not include the required ETag response header.`,
    );
  }
}

export class WorkspaceConcurrencyError extends Error {
  readonly code = 'WorkspaceConcurrencyConflict';
  constructor(name: string) {
    super(
      `Workspace '${name}' changed after it was loaded. Reload it and try again.`,
    );
  }
}
